import XComponent from './x-component'
import { serialize, inAdminWidgetPage } from '../../utilities'
import { addEventListener, show, hide } from '../../utilities/dom'

export default class Index {
  constructor(options) {
    this.options = options
    this.xComponent = new XComponent(options)
  }

  render() {
    const {container, xComponent} = this.xComponent.render(setting => {
      setting.mode === 'inline' || inAdminWidgetPage() ? this.iframeRender(container) : this.popupRender(container, xComponent)
    })
  }

  iframeRender() {
    document.querySelector('form[action="/cart/add"]').remove()
    const widget = document.getElementById('bta-product-widget')
    show(widget)
    hide(widget.querySelector('.bta-widget-close'))
  }

  popupRender(container, xComponent) {
    document.querySelectorAll('.booking-form, #booking-form').forEach(x => x.remove())

    const {
            onPopupShow, onPopupHide, target
          }         = this.options,
          modal     = container.parentNode,
          back      = modal.parentNode,
          close     = document.querySelector('.bta-widget-close'),
          form      = document.querySelector('form[action="/cart/add"]'),
          submit    = document.querySelector(target || 'form[action="/cart/add"] [type="submit"]'),
          data      = form ? serialize(form) : {},
          checkList = {form, close, back, submit, data}

    modal.classList.add("bta-widget-modal")
    back.classList.add("bta-widget-modal-back")

    addEventListener([submit], 'click', e => {
      e.preventDefault()
      show(back)
      xComponent.updateProps({data})
      onPopupShow && onPopupShow(checkList)
    })

    addEventListener([close, back], 'click', () => {
      hide(back)
      onPopupHide && onPopupHide(checkList)
    })

    addEventListener(close, 'click', () => onPopupHide && onPopupHide())
  }
}
